var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5132 22 22 17.5132 22 12C22 6.4868 17.5132 2 12 2C6.4868 2 2 6.4868 2 12C2 17.5132 6.4868 22 12 22ZM12 3.40763C16.7214 3.40763 20.5924 7.24927 20.5924 12C20.5924 16.7507 16.7214 20.5924 12 20.5924C7.27859 20.5924 3.40762 16.7214 3.40762 12C3.40762 7.27859 7.27859 3.40763 12 3.40763ZM10.3285 16.3987C9.94722 16.3987 9.62464 16.7213 9.62464 17.1025C9.62464 17.4838 9.94722 17.8064 10.3285 17.8064H14.9619C15.3431 17.8064 15.6657 17.4838 15.6657 17.1025C15.6657 16.7213 15.3431 16.3987 14.9619 16.3987H13.349V10.1817C13.349 9.80049 13.0264 9.47791 12.6452 9.47791H10.3285C9.94722 9.47791 9.62464 9.80049 9.62464 10.1817C9.62464 10.563 9.94722 10.8855 10.3285 10.8855H11.9414V16.3987H10.3285ZM12.8212 7.1609C12.8212 7.79255 12.3091 8.3046 11.6775 8.3046C11.0459 8.3046 10.5338 7.79255 10.5338 7.1609C10.5338 6.52925 11.0459 6.0172 11.6775 6.0172C12.3091 6.0172 12.8212 6.52925 12.8212 7.1609Z",
    fill: "#677B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.fd343b3a2747d58247652e86ffbdbc50.svg";
export { ForwardRef as ReactComponent };